import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon-dollar-circle',
  templateUrl: './icon-dollar-circle.component.html',
  styleUrls: ['./icon-dollar-circle.component.scss'],
  standalone: true,
})
export class IconDollarCircleComponent {
  @Input() color = '#E8EEF2';
  @Input() width = '20';
  @Input() height = '20';
}
